<template>
  <div>
    <table
      style="margin-bottom: 10px; width: 100%; border-collapse: collapse"
      cellspacing="0"
    >
      <tr>
        <td
          colspan="2"
          style="padding-bottom: 0px; border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          <div
            style="float: left; width: 50%; line-height: 18px; margin-top: 5px"
          >
          
            <strong style="font-size: 25px">{{
              dataprint.empresa.nombrec
            }}</strong
            ><br />
            <span style="color: #7a7a7a; font-size: 14px">
              Nit:
              {{ dataprint.empresa.nit | textnumber()
              }}{{ dataprint.empresa.nit | dverif() }}
            </span>

            <br />
            <span style="font-size: 12px; color: #7a7a7a">{{
              dataprint.empresa.nombre
            }}</span
            ><br />
            <span style="font-size: 14px">
              {{ dataprint.empresa.ciudad }}
              {{ dataprint.empresa.direccion }} Tel:
              {{ dataprint.empresa.telefono }}
            </span>
          </div>
          <div style="float: left; width: 50%">
            <img :src="dataprint.comprobante.urlimg" alt="" />
          </div>
        </td>
        <td
          colspan="2"
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          <div class="has-text-centered">
            <strong style="font-size: 15px">{{
              dataprint.comprobante.titulo
                ? dataprint.comprobante.titulo
                : dataprint.comprobante.nombre
            }}</strong>
          </div>
          <div class="has-text-right">
            <strong class="fontMono" style="font-size: 30px">
              {{ dataprint.comprobante.prefijo }}
              {{ dataprint.registros[0].documento }}
            </strong>
          </div>
        </td>
      </tr>
      <tr>
        <td
          colspan="4"
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          <span class="fontMono">{{
            dataprint.comprobante.factura.resolucion
          }}</span>
        </td>
      </tr>
      <tr>
        <td
          colspan="2"
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          <span class="fontMono">
            <strong>Cliente:</strong>
            {{ dataprint.registros[0].idnit.nombre }}
            <strong>Nit:</strong>
            {{ dataprint.registros[0].idnit.codigo }}
            <br />
            <strong>{{
              dataprint.registros[0].idnit.direccion ? "Dirección: " : ""
            }}</strong>
            {{ dataprint.registros[0].idnit.ciudad }}
            {{ dataprint.registros[0].idnit.direccion }}
            <strong>{{
              dataprint.registros[0].idnit.telefono ? "Teléfono: " : ""
            }}</strong>
            {{ dataprint.registros[0].idnit.telefono }}
            <strong>{{
              dataprint.registros[0].idnit.correo ? "Correo: " : ""
            }}</strong>
            {{ dataprint.registros[0].idnit.correo }}
          </span>
        </td>
        <td
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right; width:108px;"
          class="fontMono"
        >
          <strong>Fecha</strong>
          <br />
          {{ dataprint.registros[0].fecha | date() }}
        </td>
        <td
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right; width:108px;"
          class="fontMono"
        >
          <strong>Vencimiento</strong>
          <br />
          {{ dataprint.vencimiento | date() }}
        </td>
      </tr>
    </table>
    <table
      cellspacing="0"
      style="
        margin-bottom: 5px;
        font-size: 15px;
        width: 100%;
        border-collapse: collapse;
      "
    >
      <tr style="background-color: #f3f3f3">
        <th
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          Código
        </th>
        <th
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          Descripción
        </th>
        <th
          v-if="empresa.lote"
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          Lote
        </th>
        <th
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;"
        >
          Cant
        </th>
        <th
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;"
        >
          Dcto
        </th>
        <th
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;"
        >
          Vr Unit
        </th>
        <th
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;"
        >
          Sub Total
        </th>
        <th
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;"
        >
          Imp
        </th>
        <th
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;"
        >
          Valor
        </th>
      </tr>
      <tr
        v-for="(registro, index) in dataprint.registros"
        :key="index"
        class="fontMono"
      >
        <td
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          {{ registro.producto.codigo }}
        </td>
        <td
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          {{ registro.producto.descripcion }}
        </td>
        <td
          v-if="empresa.lote"
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          {{ registro.batchcodigo }}
        </td>
        <td
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;"
        >
          {{ registro.cantidad }}
        </td>
        <td
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;"
        >
          {{ registro.descuento }}%
        </td>
        <td
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;"
        >
          {{
            (registro.vlrUnitario * ((100 - registro.descuento) / 100))
              | number(2)
          }}
        </td>
        <td
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;"
        >
          {{ registro.valor | number(2) }}
        </td>
        <td
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;"
        >
          {{ registro.datosFactura.impuesto }}%
        </td>
        <td
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;"
        >
          {{
            ((registro.valor * (100 + registro.datosFactura.impuesto)) / 100)
              | number(2)
          }}
        </td>
      </tr>
      <tr>
        <td
          colspan="10"
          style="padding: 3px; background-color:#F3F3F3; border: 1px solid #dbdbdb; !important;"
        ></td>
      </tr>
      <tr class="fontMono">
        <td
          :colspan="colspan"
          rowspan="2"
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          <strong>{{ dataprint.comprobante.t3 }}</strong>
          <span>{{
            dataprint.registros[0].datosFactura
              ? dataprint.registros[0].datosFactura.texto
              : ""
          }}</span>
        </td>
        <td
          colspan="2"
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; font-size: 17px"
        >
          <strong>Subtotal</strong>
        </td>
        <td
          colspan="2"
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; font-size: 17px; text-align:right;"
        >
          <strong>{{ dataprint.totales.subtotal | number(2) }}</strong>
        </td>
      </tr>
      <tr class="fontMono">
        <td
          colspan="2"
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          Iva
        </td>
        <td
          colspan="2"
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;"
        >
          {{ dataprint.totales.iva | number(2) }}
        </td>
      </tr>
      <tr class="fontMono" style="background-color: #f3f3f3">
        <td
          :colspan="colspan1"
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; font-size: 20px;"
        >
          <strong
            >Total
            {{
              dataprint.comprobante.titulo
                ? dataprint.comprobante.titulo
                : dataprint.comprobante.nombre
            }}</strong
          >
        </td>
        <td
          colspan="2"
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important; font-size: 20px; text-align:right;"
        >
          <strong>{{ dataprint.totales.total | number(2) }}</strong>
        </td>
      </tr>
    </table>

    <p style="font-size: 13px" class="text-justify printDoc">
      <span>{{ dataprint.comprobante.mensaje }}</span
      ><br />
      <strong>{{ dataprint.comprobante.negrita }}</strong
      ><br />
      <small>{{ dataprint.comprobante.small }}</small>
    </p>
    <table
      style="
        margin-top: 15px;
        margin-bottom: 10px;
        width: 100%;
        border-collapse: collapse;
      "
    >
      <tr>
        <td
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          {{ dataprint.comprobante.t1 }}
          <br />
          <br />
          <br />
        </td>
        <td
          style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
        >
          {{ dataprint.comprobante.t2 }}
        </td>
      </tr>
    </table>
    <p class="fontMono" style="text-align: justify">
      <small>{{ dataprint.comprobante.factura.piefactura }}</small>
    </p>
    <div style="text-align: center">
      <strong>{{ cufe }}</strong>
    </div>
    <canvas id="canvas"></canvas>
  </div>
</template>

<script>
import { mapState } from "vuex";
const QRCode = require("qrcode");
export default {
  props: {
    dataprint: {
      type: Object,
    },
    cufe: String,
  },
  computed: {
    ...mapState(["empresa"]),
    colspan() {
      if (this.empresa.lote) {
        return 5;
      } else {
        return 4;
      }
    },
    colspan1() {
      if (this.empresa.lote) {
        return 7;
      } else {
        return 6;
      }
    },
  },
  methods: {
    createqr() {
      const canvas = document.getElementById("canvas");
      QRCode.toCanvas(
        canvas,
        `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${this.cufe}`,
        { errorCorrectionLevel: "L" },
        function (error) {
          if (error) console.error(error);
          console.log("success!");
        }
      );
    },
  },
  mounted() {
    this.createqr();
  },
};
</script>




// WEBPACK FOOTER //
// src/components/prints/Frapvtaelectronica.vue